import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { I18nService } from '@app/core';
import { UtilService } from './util.service';
import { timeout } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { CryptographyService } from '@app/cryptography.service'

enum ConfigType {
  ApiUrl = 1,
  CustomApiUrl = 2,
  LogInUrl = 3,
  PortalApiUrl = 4,
  PortalLoginUrl = 5
}

@Injectable()
export class ApiService {
  private API_URL: any;
  private API_PORTAL_URL: any;
  private ipClient: string;
  constructor(
    private http: Http,
    private route: Router,
    private i18nService: I18nService,
    private util: UtilService,
    private crypto: CryptographyService
  ) { }

  async get(system: string, action: string, queryParam?: string) {

    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj = {
      m: this.crypto.encrypt("GET",aesKey),
      route: this.crypto.encrypt("/" + system + "/" + action + (queryParam == null ? "" : "?" + queryParam) , aesKey),
      s: aesPublic
    }

    let url = ""
    if(environment.apiurl != "")
    {
        if(environment.apiPort == ""){
          url = environment.apiurl + environment.apiPath
        }
        else{
          url = environment.apiurl + ":" +environment.apiPort + environment.apiPath
        }
    }
    else{
      if(environment.apiPort == ""){
        url = this.util.baseUrl() + environment.apiPath
      }
      else{
        url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
      }

    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort) "/api/Core/PostApi"
    url += "/api/Core/PostApi"
    //url = "https://dpaapi.msccrm.com:443/customApi/api/Core/PostApi"

    return new Promise(resolve => {
      this.http.post(url, reqObj).toPromise().then(async (data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async getMasterAddress() {

    let url = ""
    if(environment.apiurl != "")
    {
        if(environment.apiPort == ""){
          url = environment.apiurl + environment.apiPath
        }
        else{
          url = environment.apiurl + ":" +environment.apiPort + environment.apiPath
        }
    }
    else{
      if(environment.apiPort == ""){
        url = this.util.baseUrl() + environment.apiPath
      }
      else{
        url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
      }

    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
    url += "/api/master/address"
    //url = "https://dpaapi.msccrm.com:443/customApi/api/master/address"

    return new Promise(resolve => {
      this.http.get(url).toPromise().then((data) => {
        let res = data.json();
        resolve(res);
      }).catch((err) => {
        this.util.ShowWaiting(false);
        console.error("get address failed.")
      });
    });
  }

  async getCustomAPI(system: string, action: string, queryParam?: string) {
    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj = {
      route: this.crypto.encrypt("/api/" + system + "/" + action + (queryParam == null ? "" : "?" + queryParam), aesKey),
      s: aesPublic
    }

    let url = "" 

    if(environment.apiurl != "")
    {
        if(environment.apiPort == ""){
          url = environment.apiurl + environment.apiPath
        }
        else{
          url = environment.apiurl + ":" +environment.apiPort + environment.apiPath
        }
    }
    else{
      if(environment.apiPort == ""){
        url = this.util.baseUrl() + environment.apiPath
      }
      else{
        url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
      }

    }
    
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
    url += "/api/" + system + "/" + action //+ param
    //url = "https://dpaapi.msccrm.com:443/customApi/api/" + system + "/" + action


    return new Promise(resolve => {
      this.http.post(url, reqObj).toPromise().then(async (data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async post(system: string, action: string, dataObj: object, mode?: string, branchID?: string) {
    dataObj["dpa_callby"] = '2'
    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj2 = {
      m: this.crypto.encrypt("POST", aesKey),
      route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
      s: aesPublic,
      req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
    }

    
    let url = ""
    if(environment.apiurl != "")
    {
        if(environment.apiPort == ""){
          url = environment.apiurl + environment.apiPath
        }
        else{
          url = environment.apiurl + ":" +environment.apiPort + environment.apiPath
        }
    }
    else{
      if(environment.apiPort == ""){
        url = this.util.baseUrl() + environment.apiPath
      }
      else{
        url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
      }

    }
    
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/Core/PostApi"
    //url = "https://dpaapi.msccrm.com:443/customApi/api/Core/PostApi"

    return new Promise(resolve => {
      this.http.post(url, reqObj2).toPromise().then((data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async postCustomApi(system: string, action: string, dataObj: object) {
    //var url = await this.getConfigByKey("customApiUrl") + "/" + system + "/" + action;
    
    let url = ""
    if(environment.apiurl != "")
    {
        if(environment.apiPort == ""){
          url = environment.apiurl + environment.apiPath
        }
        else{
          url = environment.apiurl + ":" +environment.apiPort + environment.apiPath
        }
    }
    else{
      if(environment.apiPort == ""){
        url = this.util.baseUrl() + environment.apiPath
      }
      else{
        url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
      }

    }
    
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/" + system + "/" + action;
    
    //url = "https://dpaapi.msccrm.com:443/customApi/api/" + system + "/" + action

    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj: any = { ...dataObj }
    reqObj = this.crypto.encryptDictValue(reqObj, aesKey)
    reqObj["s"] = aesPublic

    return new Promise(resolve => {
      this.http.post(url, reqObj).toPromise().then((data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async checkCard(req: any) {
    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/Dopa/CheckCard";
    //url = "https://dpaapi.msccrm.com:443/customApi/api/Dopa/CheckCard"



    return new Promise(resolve => {
      this.http.post(url, req).toPromise().then((data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let res = err.json();
          resolve(res);
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async put(system: string, action: string, dataObj: object, mode?: string, branchID?: string) {
    dataObj["dpa_callby"] = '2'

    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj2 = {
      m: this.crypto.encrypt("PUT", aesKey),
      route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
      s: aesPublic,
      req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
    }
    let url = ""
    if(environment.apiurl != "")
    {
        if(environment.apiPort == ""){
          url = environment.apiurl + environment.apiPath
        }
        else{
          url = environment.apiurl + ":" +environment.apiPort + environment.apiPath
        }
    }
    else{
      if(environment.apiPort == ""){
        url = this.util.baseUrl() + environment.apiPath
      }
      else{
        url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
      }

    }
    
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/Core/PostApi"
    //url = "https://dpaapi.msccrm.com:443/customApi/api/Core/PostApi"

    return new Promise(resolve => {
      this.http.post(url, reqObj2).toPromise().then((data) => {
        // resolve(data);
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async postOther(url: string, datapost: object, contentType: string) {
    let requestHeaders: any = { 'Content-Type': 'application/x-www-form-urlencoded' };

    var urlencoded = new URLSearchParams();
    urlencoded.append("grant_type", "authorization_code");
    urlencoded.append("code", datapost["code"]);
    urlencoded.append("redirect_uri", this.util.baseUrl() + "/mainmenu/login");
    urlencoded.append("client_id", "1654952386");
    urlencoded.append("client_secret", "d129b1c240d16dde27204dadbc5f612c");

    const authHeader = new Headers();
    authHeader.append('Authorization', `Bearer`);

    var requestOptions: RequestInit = {
      method: 'POST',
      body: urlencoded,
      redirect: 'follow',
      headers: requestHeaders
    };

    return fetch("https://api.line.me/oauth2/v2.1/token", requestOptions)
      .then(response =>
        response.json()
      )
      .then(result => {
        return result
      })
      .catch(error =>
        console.log('error', error)
      );
  }

  async delete(system: string, action: string) {
    if (this.API_URL == undefined || this.API_URL == null) {
      this.API_URL = await this.getConfig();
    }

    if (this.ipClient == undefined || this.ipClient == null) {
      this.ipClient = sessionStorage.getItem("clientIP");
    }

    const url = this.API_URL + '/' + system + '/' + action;

    const header = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: header });

    return new Promise(resolve => {
      this.http.delete(url, options).toPromise().then(async (data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]))
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async getConfig() {
    let configData = '';

    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(this.crypto.decrypt(res.apiUrl))
      }).catch((err) => {
        this.util.ShowWaiting(false);
        // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
        // this.route.navigate(['/error']);
      });
    });
  }



  async getConfigByKey(key: string) {
    let configData = '';

    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(this.crypto.decrypt(res.customApiUrl))
      }).catch((err) => {
        this.util.ShowWaiting(false);
        // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
        // this.route.navigate(['/error']);
      });
    });
  }

  async getNotiApiUrl() {
    let configData = '';

    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(res.notiApiUrl)
      }).catch((err) => {
        this.util.ShowWaiting(false);
        // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
        // this.route.navigate(['/error']);
      });
    });
  }

  async postnotauthen(system: string, action: string, dataObj: object, mode?: string, branchID?: string) {

    if (this.API_URL == undefined || this.API_URL == null) {
      this.API_URL = await this.getConfig();
    }


    if (this.ipClient == undefined || this.ipClient == null) {
      this.ipClient = localStorage.getItem("clientIP");
    }



    const url = this.API_URL + '/' + system + '/' + action;

    const header = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: header });

    // var datahead = {};
    // datahead["client_ip"] = this.ipClient;
    // datahead["lang"] = this.i18nService.language;

    var datapost = {};
    datapost["user"] = this.util.GetUserID();
    datapost["ip"] = this.util.GetClientIP();
    datapost["lang"] = this.i18nService.language;
    datapost["requestData"] = dataObj;
    datapost["mode"] = mode;
    datapost["branch_id"] = branchID;
    //  dataObj = Object.assign(datahead, dataObj);
    return new Promise(resolve => {
      this.http.post(url, datapost, options).toPromise().then((data) => {
        const res = data.json();
        resolve(res);
      }).catch((err) => {
        this.util.ShowWaiting(false);
        resolve(null)
        //this.util.ErrorDialog('System Error : ' + err);
      });
    });
  }

  async getConfigLogin() {
    let configData = '';

    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(res.UrlLogin)
      }).catch((err) => {
        this.util.ShowWaiting(false);
        // localStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
        // this.route.navigate(['/error']);
      });
    });
  }

  async getTokenConfig() {
    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(res)
      }).catch((err) => {
        return null
      });
    });
  }

  async getToken() {
    let config: any = await this.getTokenConfig()
    const url = this.crypto.decrypt(config.getTokenUrl)
    let req: any = {
      "username": config.getTokenUser,
      "password": config.getTokenPassword
    }

    const header = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: header });

    return new Promise(resolve => {
      this.http.post(url, req, options).toPromise().then((data) => {
        const res = data.json();
        resolve(res.AccessToken);
      }).catch((err) => {
        if (err.statusText == 'OK') {
          resolve(err)
        }
        else {
          this.util.ShowWaiting(false);
          resolve(null)
          //this.util.ErrorDialog('System Error : ' + err);
        }
      });
    });
  }

  async getKey() {
    let url = ""
    if(environment.apiPort == ""){
      //url = environment.apiurl + environment.apiPath
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      //url = environment.apiurl + ":" +environment.apiPort + environment.apiPath
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
    //url =  "https://dpaapi.msccrm.com:443/customApi/api/" + "Key" + "/" + "GetKey"
    url +=  "/api/" + "Key" + "/" + "GetKey"

    return new Promise(resolve => {
      this.http.get(url).toPromise().then(async (data) =>  {
        let res = data.json();
        resolve(res);
      }).catch((err) => {
        this.util.ShowWaiting(false);
      });
    });
  }

  async keyFromCk(){
    let ck: any = JSON.parse(localStorage.getItem("dpa_portal"))

    if (ck != null && ck.pbk != null && ck.pbk != ""){
        return ck.pbk
    }
    else {
      if(ck == null){
        ck = {}
      }
      let getKeyRes: any = await this.getKey()
      ck.pbk = getKeyRes
      localStorage.setItem("dpa_portal", JSON.stringify(ck))
      return getKeyRes;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utility/api.service.ts